<template>
  <div class="page">
    <div class="intro">
      <div class="container">
        <div class="intro-title">店收盈音箱</div>
        <div class="intro-msg">
          <div class="item">
            <img src="@/assets/new/super_volume.png" alt="" />
            <span>超大音量播报</span>
          </div>
          <div class="item">
            <img src="@/assets/new/communication_stabilization.png" alt="" />
            <span>通信稳定</span>
          </div>
          <div class="item">
            <img src="@/assets/new/adaptive.png" alt="" />
            <span>适配各种场合</span>
          </div>
        </div>
        <div class="intro-but">
          <el-button type="primary" @click="openModal">免费试用</el-button>
          <el-button type="primary" @click="openModal">立即咨询</el-button>
        </div>
      </div>
    </div>

    <div class="second">
      <div class="container">
        <div class="left">
          <img src="@/assets/new/voice_nav.png" alt="" />
        </div>
        <div class="right">
          <div class="item">
            <span>·</span>
            <div>
              <p>
                支持多种支付方式，微信、支付宝、云闪付等收款码和播报音箱融合一体，笔笔交易实时播报( 交易成功、交易取消均会播报)
              </p>
            </div>
          </div>
          <div class="item">
            <span>·</span>
            <div>
              <p>
                超大音量播报，再嘈杂的环境也能听清，不用担心漏单推荐顾客流动性强、环境
              </p>
            </div>
          </div>
          <div class="item">
            <span>·</span>
            <div>
              <p>
                数字屏显展现收款金额，商户轻松收款可悬挂、可摆放，适配更多场景
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="third">
      <div class="container">
        <div class="right">
          <div class="title">
            <span>交接班查询</span>
          </div>
          <div class="cont">
            <span>员工状态轻松查，连锁开店更便捷</span>
          </div>
        </div>
      </div>
    </div>

    <div class="fourth">
      <div class="container">
        <div class="title">适用场景</div>
        <div class="content">
          <div class="item">
            <img src="@/assets/new/wet_market.png" alt="" />
          </div>
          <div class="item">
            <img src="@/assets/new/breakfast_bars.png" alt="" />
          </div>
          <div class="item">
            <img src="@/assets/new/snack_bar.png" alt="" />
          </div>
          <div class="item">
            <img src="@/assets/new/fast_food_restaurant.png" alt="" />
          </div>
        </div>
      </div>
    </div>

    <Dialog ref="dialog"></Dialog>
  </div>
</template>

<script>
import Dialog from './dialog';
export default {
  name: "LoudspeakerBox",
  components:{
    Dialog
  },
  data() {
    return {};
  },
  methods: {
    openModal(){
      this.$refs.dialog.openLog()
    },
  },
};
</script>

<style scoped lang="scss">
.page {
  width: 100%;
  padding-top: 65px;
  background-color: #f5f8ff;
}
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 第一屏 */
.intro {
  background: url(../assets/new/voice_header.jpg) no-repeat center;
  background-size: cover;
  padding: 60px 0;
  color: #fff;
  display: flex;
  align-items: center;
}
.intro-title {
  font-size: 28px;
  margin-bottom: 20px;
}
.intro-msg {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  font-size: 16px;
}
.intro-msg .item {
  display: flex;
  align-items: center;
}
.intro-msg .item img {
  width: 24px;
  height: 24px;
  margin-right: 6px;
}
.intro-but {
  margin-top: 30px;
  display: flex;
  gap: 15px;
}
.intro-but button:nth-of-type(1) {
  color: #de1f26;
  background-color: #fff;
  border: 1px solid #de1f26;
}
.intro-but button:nth-of-type(2) {
  color: #fff;
  background-color: #de1f26;
  border: 1px solid #fff;
}

/* 第二屏 */
.second {
  padding: 50px 0;
}
.second .container {
  display: flex;
  flex-direction: column;
  gap: 30px;
}
.second .left {
  width: 100%;
  text-align: center;
}
.second .left img {
  max-width: 100%;
  height: auto;
}
.second .right {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.second .right .item {
  display: flex;
  align-items: flex-start;
}
.second .right .item span {
  font-size: 30px;
  line-height: 30px;
  color: #de1f26;
}
.second .right .item div {
  margin-left: 15px;
}
.second .right .item div p {
  font-size: 16px;
  line-height: 1.6;
}

/* 第三屏 */
.third {
  background: url(../assets/new/scan_third.png) no-repeat center;
  background-size: cover;
  padding: 80px 0;
}
.third .right {
  width: 100%;
}
.third .title {
  font-size: 24px;
}
.third .cont {
  font-size: 16px;
  color: #707172;
  margin-top: 20px;
}

/* 第四屏 */
.fourth {
  padding: 50px 0;
}
.fourth .title {
  font-size: 24px;
  text-align: center;
}
.fourth .content {
  display: flex;
  flex-wrap: wrap;
  margin-top: 30px;
}
.fourth .content .item {
  width: 50%;
  padding: 10px;
}
.fourth .content .item img {
  width: 100%;
}

/* ====================== PC端 ====================== */
@media (min-width: 768px) {
  .intro {
    height: 500px;
    padding: 0;
  }
  .intro-title {
    font-size: 48px;
  }
  .intro-msg {
    font-size: 20px;
  }
  .intro-but {
    margin-top: 50px;
  }

  .second {
    padding: 80px 0;
  }
  .second .container {
    flex-direction: row;
    align-items: center;
  }
  .second .left {
    width: 50%;
    text-align: left;
  }
  .second .right {
    width: 50%;
    padding-left: 5%;
  }
  .second .right .item span {
    font-size: 40px;
    line-height: 40px;
  }
  .second .right .item div p {
    font-size: 20px;
    line-height: 40px;
  }

  .third {
    height: 500px;
    padding: 0;
    display: flex;
    align-items: center;
  }
  .third .right {
    width: 40%;
    margin-left: auto;
  }
  .third .title {
    font-size: 40px;
    margin-top: 0;
  }
  .third .cont {
    font-size: 20px;
    margin-top: 50px;
  }

  .fourth {
    padding: 80px 0;
  }
  .fourth .title {
    font-size: 40px;
  }
  .fourth .content {
    margin-top: 50px;
    flex-wrap: nowrap;
  }
  .fourth .content .item {
    width: 25%;
  }
}

h3,
h4,
h5,
p {
  margin: 0;
  padding: 0;
}
</style>
